import ThisModule from "./MeetingSummary";

export default ThisModule;
